// extracted by mini-css-extract-plugin
export default {"noDataWrapper":"_errors_noDataWrapper__UR59X","noRaceDataWrapper":"_errors_noRaceDataWrapper__fziR3"};